export type FinalizePurchasePayload = {
  uuid: string;
  stripePaymentMethodId: string;
};

export type FinalizePurchaseResponse = {
  email?: string;
  stripe_invoice?: {
    tax?: number;
    automatic_tax?: {
      enabled: boolean;
      status: string;
    };
  };
  stripe_invoice_id?: string;
};

export async function finalizePurchase({
  uuid,
  stripePaymentMethodId,
}: FinalizePurchasePayload): Promise<{
  data: FinalizePurchaseResponse;
  error?: string;
}> {
  const query = `
    mutation FINALIZE_PURCHASE($uuid: String!, $params: FinalizePurchaseInput!) {
      finalize_purchase(uuid: $uuid, params: $params) {
        email
        stripe_invoice 
        stripe_invoice_id
      }
    }
  `;

  const res = await fetch(import.meta.env.VITE_PURCHASE_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      operationName: "FINALIZE_PURCHASE",
      query,
      variables: {
        uuid,
        params: {
          stripe_payment_method_id: stripePaymentMethodId,
        },
      },
    }),
  });

  const json = await res.json();

  if (json.errors?.length) {
    throw new Error(`${json.errors[0].message}. Code: finalize_purchase`);
  }

  const data = json?.data?.finalize_purchase ?? {};

  return {
    data,
    error: undefined,
  };
}
